import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"
import vuetify from './plugins/vuetify'
import smoothScroll from './plugins/smooth-scroll'
import reveal from './plugins/reveal'

const app = createApp(App)

app.config.globalProperties.$axios = axios

app.use(router)
app.use(store)
app.use(vuetify)
app.use(smoothScroll)
app.use(reveal)

app.mount('#app')
